import { ModalBuilder, notifySuccess, Form } from "@redriver/cinnamon";
import React from "react";
import { voidEnvelope } from "./actions";
import { useTranslation } from "react-i18next";
import { TranslatedModal } from "features/../../../shared/components/modals";
import { DropdownItem } from "semantic-ui-react";
import { NonPropagatingInput } from "features/../../../shared/components/forms/NonPropagatingField";

const VoidEnvelope = ({ sheet, onSubmitted }) => {
  const { t } = useTranslation("agreements");
  const { sheetId } = sheet;
  return (
    <ModalBuilder
      withForm
      submitAction={voidEnvelope}
      submitParams={{ sheetId }}
      onSubmitted={(response) => {
        notifySuccess(t("Action.Void_Envelope_Success"));
        onSubmitted(response);
      }}
      renderTrigger={(trigger) => (
        <DropdownItem onClick={trigger}>
          {t("SheetActions.VoidEnvelope.VoidEnvelope")}
        </DropdownItem>
      )}
      renderModal={(modalProps, formProps) => (
        <TranslatedModal.Confirmation
          {...modalProps}
          header={t("SheetActions.VoidEnvelope.Confirmation")}
        >
          <Form {...formProps}>
            <div className="flex">
              <NonPropagatingInput
                field="voidReason"
                label={t("SheetActions.VoidEnvelope.Void_Reason")}
                width={25}
              />
            </div>
          </Form>
        </TranslatedModal.Confirmation>
      )}
    />
  );
};

export default VoidEnvelope;
